// Dependencies
import React from 'react';
import radium from 'radium';
import {ThemeContext} from "../../../components/theme/Theme.jsx";

function ShoppingCartSubTotal(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		subTotalLabel: {
			fontWeight: '800',
			textTransform: 'uppercase',
		},
		subTotalContainer: {
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'center',
			borderTop: '1px solid',
			borderTopColor: context.themeManager
				.value('overview-shopping-cart-total', 'borderTopColor', 'fg-color-text'),
			borderBottom: '1px solid',
			borderBottomColor: context.themeManager
				.value('overview-shopping-cart-total', 'borderBottomColor', 'fg-color-text'),
			margin: '3em 0 2em',
			padding: '.5em 0',
			backgroundColor: context.themeManager
				.value('overview-shopping-cart-total', 'backgroundColor', 'bg-color-zig-zag-box'),
		},
		subTotal: {
			fontWeight: '800'
		}
	}
	return (
		<div style={style.subTotalContainer}>
			<span style={style.subTotalLabel}>Zwischensumme:</span>
			<span style={style.subTotal} className="price">
				{props.subTotal.toFixed(2)} €
			</span>
		</div>
	);
}

export default radium(ShoppingCartSubTotal);
